const PaymentService = {
    getPaymentHistory (pageSize = 5, page = 1, fromDate = '', toDate = '', projectId = '') {
        return window.$http.get(
            '/payment-history/',
            {
                params: {
                    'page_size': pageSize,
                    page,
                    'created_time__gte': fromDate,
                    'created_time__lte': toDate,
                    'project': projectId
                }
            })
    },
    verifyAPIPackageOrder (projectId, orderId) {
        return window.$http.put(`/projects/${projectId}/check-buy-api-package/${orderId}/`)
    },
    cancelAPIPackageOrder (projectId, orderId) {
        return window.$http.delete(`/projects/${projectId}/cancel-buy-api-package/${orderId}/`)
    }
}

export default PaymentService
